if (!customElements.get('product-line-items')) {
  customElements.define(
    'product-line-items',
    class ProductLineItems extends HTMLElement {
      constructor() {
        super();
        this.imageDefaultLabel = 'CLICK TO UPLOAD YOUR PHOTO';
        this.bindEvents();
      }

      bindEvents() {

        this.querySelectorAll('.product-line-items .product-line-item-image-upload').forEach((element, index, arr) => {

          if (element.type === 'file' ) {

            let requiredFileSize = element.getAttribute('data-max-size');

            if (typeof requiredFileSize !== 'undefined' && requiredFileSize !== '') {

              let convertedRequiredFileSize = requiredFileSize.replace(/\D/g, '');
              convertedRequiredFileSize = Math.round((convertedRequiredFileSize * 1024));

              let imageName = document.getElementById(`image_upload_label_${index + 1}`);
              let fileUploadErrorLabel = document.getElementById(`image_upload_error_label_${index + 1}`);

              imageName.innerHTML = this.imageDefaultLabel;

              element.addEventListener('change', (ctx) => {

                if (ctx.target.files.length <= 0) {
                  imageName.innerHTML = this.imageDefaultLabel;
                  return;
                }
                
                imageName.innerHTML = ctx.target.files[0].name;
  
                const fileSizeInBytes = ctx.target.files[0].size;
                const fileSizeInKb = Math.round((fileSizeInBytes / 1024));

                if (fileSizeInKb >= convertedRequiredFileSize) {
                  fileUploadErrorLabel.innerHTML = `File too big. Please select a file less than ${requiredFileSize}.`;
                }
              });
            }
          }
        });
      }
    }
  );
}
